var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "atm / x_assets / oval / normal copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-20.0%",
    y: "-20.0%",
    width: "140.0%",
    height: "140.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1280,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-cambia-ambiente-open-scroll",
    transform: "translate(-929.000000, -900.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31-Copy",
    transform: "translate(0.000000, 846.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm-/-x_assets-/-oval-/-normal-copy-3",
    filter: "url(#filter-1)",
    transform: "translate(955.000000, 80.000000) scale(-1, 1) rotate(-180.000000) translate(-955.000000, -80.000000) translate(935.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(19.000000, 20.000000) rotate(-135.000000) translate(-19.000000, -20.000000) translate(14.000000, 15.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.909090909,-1.5 C1.68878703,-1.5 2.32953959,-0.905111917 2.40222433,-0.144460011 L2.40909091,0 L2.40909091,9.09090909 C2.40909091,9.91933622 1.73751803,10.5909091 0.909090909,10.5909091 C0.129394792,10.5909091 -0.511357769,9.99602101 -0.584042513,9.2353691 L-0.590909091,9.09090909 L-0.590909091,0 C-0.590909091,-0.828427125 0.0806637843,-1.5 0.909090909,-1.5 Z",
    id: "Line-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,7.59090909 C10.8284271,7.59090909 11.5,8.26248197 11.5,9.09090909 C11.5,9.87060521 10.9051119,10.5113578 10.14446,10.5840425 L10,10.5909091 L0.909090909,10.5909091 C0.0806637843,10.5909091 -0.590909091,9.91933622 -0.590909091,9.09090909 C-0.590909091,8.31121297 0.00397899236,7.67046041 0.764630899,7.59777567 L0.909090909,7.59090909 L10,7.59090909 Z",
    id: "Line-4"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.5b8d4bfb.svg";
export { ForwardRef as ReactComponent };